"use strict";

module.exports = function () {
	require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/core/core.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/validation-forms/validation-forms.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/notifications/notifications.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/tabs-accordions/tabs-accordions.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/tooltips/tooltips.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/table-responsive/table-responsive.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/navigation/navigation.js");

require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/slider/slider.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/media/media.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/media-album/media-album.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/media-list/media-list.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/bods/bods.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/news/news.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/search/search.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/subscribe/subscribe.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/contacts-map/contacts-map.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/popup/popup.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/print/print.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/dropdown/dropdown.js");

require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/select/select.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/corporate-governance/corporate-governance.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/animation/animation.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/map/map.js");
require("/pub/www/kazchrome/releases/20191220100429Z/frontend/components/biography/biography.js");;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/callback-loader/callback-loader.js!./node_modules/babel-loader/lib?{"cacheDirectory":"cache","presets":["es2015"],"plugins":["transform-es3-member-expression-literals","transform-es3-property-literals"]}!./frontend/components.js
// module id = 173
// module chunks = 0